import { t } from 'i18next'

export type FieldNamesByEntityProps = {
  fieldName: ResponseGetAuditLogFieldNames
  entity: ResponseGetAuditLogEntities
  action: ResponseGetAuditLogActions
}

type FieldNamesByEntityTerms = {
  [key in ResponseGetAuditLogEntities]: {
    [key in ResponseGetAuditLogActions]?: {
      [key in ResponseGetAuditLogFieldNames]?: string
    }
  }
}

export const labelsByEntities: FieldNamesByEntityTerms = {
  campaign: {
    create: {
      payload_create: t('rm:campaign.logs.create')
    },
    update: {
      active: t('rm:campaign.logs.update.active'),
      ads: t('rm:campaign.logs.update.ads'),
      name: t('rm:campaign.logs.update.name'),
      start_at: t('rm:campaign.logs.update.start_at'),
      end_at: t('rm:campaign.logs.update.end_at'),
      description: t('rm:campaign.logs.update.description'),
      'settings.daily_budget': t(
        'rm:campaign.logs.update.settings.daily_budget'
      ),
      total_budget: t('rm:campaign.logs.update.settings.total_budget'),
      'settings.cpm': t('rm:campaign.logs.update.settings.cpm'),
      'settings.cpc': t('rm:campaign.logs.update.settings.cpc'),
      'settings.products': t('rm:campaign.logs.update.settings.products'),
      'settings.budget_type': t('rm:settings.budget_type.title'),
      destination_urls: t('rm:campaign.logs.update.destination_urls')
    }
  },
  ad: {
    create: {
      payload_create: t('rm:ad.logs.create'),
      'settings.products': t('rm:ad.logs.create')
    },
    update: {
      active: t('rm:ad.logs.update.active'),
      'settings.cpm': t('rm:ad.logs.update.settings.cpm'),
      'settings.cpc': t('rm:ad.logs.update.settings.cpc'),
      'settings.url': t('rm:ad.logs.update.settings.destinations'),
      url: t('rm:ad.logs.update.settings.destinations'),
      'settings.destinations': t('rm:ad.logs.update.settings.destinations')
    }
  },
  campaign_keyword: {
    create: {
      payload_create: t('rm:campaign.logs.create.keyword')
    },
    update: {
      active: t('rm:campaign.logs.update.keyword.active')
    }
  },
  campaign_category: {
    create: {
      payload_create: t('rm:campaign.logs.create.category')
    },
    update: {
      active: t('rm:campaign.logs.update.category.active')
    }
  },
  campaign_subpublisher: {
    create: {
      payload_create: t('rm:campaign.logs.create.publisher')
    },
    update: {
      active: t('rm:campaign.logs.update.publisher.active')
    }
  },
  campaign_checking_account: {
    create: {
      payload_create: t('rm:campaign.logs.checkingAccount.insertionOrder')
    },
    delete: {
      payload_delete: t('rm:campaign.logs.checkingAccount.insertionOrder')
    }
  },
  campaign_destination_url: {
    create: {
      payload_create: t('rm:campaign.logs.create.destination_urls')
    },
    update: {
      destination_urls: t('rm:campaign.logs.update.destination_urls')
    }
  },
  network_publishers_campaigns_status: {
    update: {
      destination_urls: t('rm:campaign.logs.update.destination_urls')
    }
  }
}

export const fieldNamesByEntity = ({
  fieldName,
  entity,
  action
}: FieldNamesByEntityProps) => {
  return labelsByEntities?.[entity]?.[action]?.[fieldName] || fieldName
}
